import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";
import { useTranslation } from 'react-i18next';

function PlanetAspects({ tableData }) {
    const { t } = useTranslation();

    const dataTableData = {
        columns: [
            { Header: t("Planet"), accessor: "planet" },
            { Header: t("Nekatha"), accessor: "nekathaAdhipathi" },
            { Header: t("UpaGraha"), accessor: "upaGraha" },
            { Header: t("BhavaPlanetAspectsCol4"), accessor: "aithiBhavaya" },
            // thenpath grahayange nekthwala lagumagath
            { Header: t("BhavaPlanetAspectsCol5"), accessor: "thenpathBhavaya" },
            // thenpath bhavay
            { Header: t("BhavaPlanetAspectsCol6"), accessor: "nakAdipathiAithiBhavaya" },
            // අධිපති
            { Header: t("BhavaPlanetAspectsCol7"), accessor: "nakAdipathiThenpathBhavaya" }
        ],
        rows: tableData
    }

    return (
        <MDBox pt={0} pb={1} id="planet-aspects-ref">
            <MDBox mb={1}>
                <Card>
                    <DataTable
                        canSearch={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        table={dataTableData} />
                </Card>
            </MDBox>
        </MDBox>
    );
};

PlanetAspects.propTypes = {
    tableData: PropTypes.any
};

export default PlanetAspects;
